/* @jsx h */
import { defineComponent, h } from "vue";
import { PageComponent, useLocalization } from "@lemmonhq/uikit";

// Dashboard shell for Group mode. Hosts the consolidated reporting subpages and
// renders the active one via its RouterView.
export const GroupDashboardPage = defineComponent({
  name: "GroupDashboardPage",
  setup() {
    const { t } = useLocalization();

    return () => (
      <PageComponent
        title={t("admin.common.dashboard")}
        titleIcon="dashboard"
        subpages={[
          {
            name: t("admin.overview.title"),
            icon: "monitoring",
            href: "/group/dashboard",
          },
          {
            name: t("admin.dashboard.revenue"),
            icon: "insights",
            href: "/group/dashboard/revenue",
          },
          {
            name: t("admin.dataroom.title"),
            icon: "database",
            href: "/group/dashboard/dataroom",
          },
        ]}
      />
    );
  },
});
